import { OrdersState } from '@pages/payment-management/store/state/orders.state';
import { PaymentSettingsState } from '@pages/payment-management/store/state/payment-settings.state';
import { ProductCategoriesState } from '@pages/payment-management/store/state/product-categories.state';
import { BillRunStatusState } from '@pages/payment-management/store/state/bill-run-status.state';
import { PaymentMethodsState } from '@pages/payment-management/store/state/payment-methods.state';
import { PaymentTypesState } from '@pages/payment-management/store/state/payment-types.state';
import { PaymentMethodsRequireAttentionCountState } from '@pages/payment-management/store/state/payment-methods-require-attention-count.state';
import { PaymentReassignmentFailedCountState } from '@pages/payment-management/store/state/payment-reassignment-failed-count.state';

export const paymentManagementState = [
  OrdersState,
  PaymentSettingsState,
  ProductCategoriesState,
  PaymentMethodsState,
  BillRunStatusState,
  PaymentTypesState,
  PaymentMethodsRequireAttentionCountState,
  PaymentReassignmentFailedCountState,
];
